import { render, staticRenderFns } from "./wagestatistics.vue?vue&type=template&id=6049aa7e"
import script from "./wagestatistics.vue?vue&type=script&lang=js"
export * from "./wagestatistics.vue?vue&type=script&lang=js"
import style0 from "./wagestatistics.vue?vue&type=style&index=0&id=6049aa7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports